import { BaseService } from "./BaseService";

export const ConvenioFederalService = {
    async index(filter = null) {
        try {
            return await BaseService.fetchResponseFromAPIPost('convenios-federais/search', filter);
        } catch (error) {
            console.error('Ocorreu um erro ao listar todos convênios federais:', error);
            return false;
        }
    },
    async show(id) {
        try {
            return await BaseService.fetchResponseFromAPIGet(`convenios-federais/${id}`);
        } catch (error) {
            console.error('Ocorreu um erro durante a busca do convênio federal:', error);
            return false;
        }
    },
    async autocomplete(field, search = '') {
        try {
            const params = search ? `?search=${encodeURIComponent(search)}` : '';
            return await BaseService.fetchResponseFromAPIGet(`convenios-federais/autocomplete/${field}${params}`);
        } catch (error) {
            console.error('Ocorreu um erro ao buscar opções de autocomplete:', error);
            return false;
        }
    },
    async getUnidadesOptions(search = '') {
        try {
            const params = search ? `?search=${encodeURIComponent(search)}` : '';
            return await BaseService.fetchResponseFromAPIGet(`convenios-federais/options/unidades${params}`);
        } catch (error) {
            console.error('Ocorreu um erro ao buscar opções de unidades:', error);
            return false;
        }
    },
    async getCidadesOptions(search = '') {
        try {
            const params = search ? `?search=${encodeURIComponent(search)}` : '';
            return await BaseService.fetchResponseFromAPIGet(`convenios-federais/options/cidades${params}`);
        } catch (error) {
            console.error('Ocorreu um erro ao buscar opções de cidades:', error);
            return false;
        }
    },
    async getAnosOptions() {
        try {
            return await BaseService.fetchResponseFromAPIGet('convenios-federais/options/anos');
        } catch (error) {
            console.error('Ocorreu um erro ao buscar opções de anos:', error);
            return false;
        }
    },
    async getGerenciasOptions() {
        try {
            return await BaseService.fetchResponseFromAPIGet('convenios-federais/options/gerencias');
        } catch (error) {
            console.error('Ocorreu um erro ao buscar opções de gerências:', error);
            return false;
        }
    },
    async getTiposEmendaOptions() {
        try {
            return await BaseService.fetchResponseFromAPIGet('convenios-federais/options/tipos-emenda');
        } catch (error) {
            console.error('Ocorreu um erro ao buscar opções de tipos de emenda:', error);
            return false;
        }
    },
    async getModalidadesOptions() {
        try {
            return await BaseService.fetchResponseFromAPIGet('convenios-federais/options/modalidades');
        } catch (error) {
            console.error('Ocorreu um erro ao buscar opções de modalidades:', error);
            return false;
        }
    },
}

